export default __webpack_public_path__ + "mobile_04-cbb5dc8d78990c1c5f59a50b093c4e55.jpg";